import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
// import { insh as inshst } from "../../../Context/InshSt";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
import { sto } from "../../../Context/InshData";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";
import { uri } from "../../../help/Api";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { insh, wsto } from "../../../Context/InshData";
import PricesLevelsTable from "./PricesLevelsTable";
import PricesLevelsForms from "./PricesLevelsForms";
import PumpsAppbar from "../Pumps/PumpsAppbar";
import PricesLevelsFSearch from "./PricesLevelsFSearch";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.red[50],
        borderColor: colors.red[300],
    },
}));

export default function PricesLevels(props) {
    const { AutoOptions,
    } = props;
    const clasess = useStyles();
    const defaultBranch = AutoOptions.Branches.find((obj) => obj.id === sto.branchi);
    // setBranch(defaultBranch);


    const valueLevels = {
        id: AutoOptions?.other?.lastid ?? 1,
        level: "",
        barcode: "",
        levelName: "",
        branchName: "",
        itemName: "",
        unitName: "",
        item: "",
        unit: "",
        branch: "",
        price: 0,
        minPrice: 0,
        maxPrice: 0,
        nameS: "",
        barcodeS: "",
        branchS: {},
        db_name: sto?.db_name,
    };
    const AutoValueLevels = {
        item: {},
        branch: {},
        branchS: {},
        level: {},
        item: {},
        unit: {},
    };
    const clasCAB = useStylesCAB();
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [isSearch, setIsSearch] = useState(true);
    const [prevent, setPrevent] = React.useState(true);
    const [optionsUnits, setOptionsUnits] = React.useState([]);
    const [rptParams, setRptParams] = React.useState(valueLevels);
    const [uiElement, setUiElement] = useState({});

    const [rptParamsAuto, setRptParamsAuto] = React.useState(AutoValueLevels);
    const clasBA = useStylesBA();


    const { t } = useTranslation(["forms"]);
    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const timer = React.useRef();
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});
    const his = useHistory();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success?.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };
    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };


    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {

        if (propName === "item") {
            setRptParams({ ...rptParams, [propName]: newValue.id });
            setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
            getBarcodeMulti(newValue.barcode);
        } else if (propName === "unit") {
            setRptParams({
                ...rptParams, [propName]: newValue.unit, price: newValue.sale, minPrice: newValue.sale,
                maxPrice: newValue.sale
            });
            setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
        } else {
            setRptParams({ ...rptParams, [propName]: newValue.id });
            setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
        }
    };

    const onChangeSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        getBarcodeMulti(rptParams?.barcode);

    };
    const getBarcodeMulti = async (itemcode) => {
        let item = null;
        let units = null;
        let defaultUnits = null;
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}&&emp=${sto.empi}&&safe=${1}`
        } else {
            Urls = `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}&&emp=${sto.empi}&&safe=${1}&&db_name=${sto?.db_name}`
        }
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                defaultUnits = res.data?.unitsSub[0];
                units = res.data?.unitsSub;
                item = res.data?.barcodes[0];
            })
            .catch((err) => {
                console.log(err);
            });
        if (item != null) {
            await getNormalData({ ...item }, { ...defaultUnits }, units);
            // setIsBarcode(true);
        } else {
            toast.error(t("item-not-found-for-barcode"));
        }
    };
    const getNormalData = (dataCode, unitF, Units) => {
        setOptionsUnits(Units);
        let res = { item: {} };

        AutoOptions.InvItems.map((x) => {
            if (x.id == dataCode.curr) res.item = x;
        });
        setRptParams({
            ...rptParams,
            barcode: dataCode.barcode,
            price: dataCode?.sale,
            item: dataCode.curr,
            itemName: dataCode.symbol,
            unitName: unitF.unitName,
            unit: dataCode.unit,
        });
        setRptParamsAuto({
            ...AutoValueLevels,
            item: res.item,
            unit: unitF,
        });
    };
    const onRowClick = async (row, Units) => {
        setPrevent(false);


        let res = { branch: {}, item: {}, unit: {}, level: {} };

        AutoOptions.InvItems.map((x) => {
            if (x.id == row.item) res.item = x;
        });
        AutoOptions.Levels.map((x) => {
            if (x.id == row.level) res.level = x;
        });
        AutoOptions.Units.map((x) => {
            if (x.id == row.unit) res.unit = x;
        });
        AutoOptions.Branches.map((x) => {
            if (x.id == row.branch) res.branch = x;
        });
        const unitsOptions = [...Units,
        { ...res.unit, unitName: res.unit.name }
        ]
        setOptionsUnits(unitsOptions);

        setRptParamsAuto({
            ...AutoValueLevels,
            branch: res.branch,
            item: res.item,
            level: res.level,
            unit: res.unit,
        });

        setRptParams({
            ...rptParams,
            id: row.id,
            price: row.price,
            level: row.level,
            levelName: res.level.name,
            branchName: res.branch.name,
            itemName: res.item.name,
            unitName: res.unit.name,
            branch: row.branch,
            item: row.item,
            minPrice: row.minPrice,
            maxPrice: row.maxPrice,
            unit: row.unit
        });
    };

    const viewHandle = async () => {
        setData([]);
        setFetching(true);
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `RptSafes/LevelsPriceSearch?branch=${rptParams?.branch}&&item_code=${rptParams.barcodeS}
                &&item_name=${rptParams.nameS}`
        } else {
            Urls = `RptSafes/LevelsPriceSearch?branch=${rptParams?.branch}&&item_code=${rptParams.barcodeS}
                &&item_name=${rptParams.nameS}&&db_name=${sto.db_name}`
        }
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                const data2 = res.data.map((row, i) => {
                    let res = { branch: {}, item: {}, unit: {}, level: {} };
                    AutoOptions.InvItems.map((x) => {
                        if (x.id == row.item) res.item = x;
                    });
                    AutoOptions.Levels.map((x) => {
                        if (x.id == row.level) res.level = x;
                    });
                    AutoOptions.Units.map((x) => {
                        if (x.id == row.unit) res.unit = x;
                    });
                    AutoOptions.Branches.map((x) => {
                        if (x.id == row.branch) res.branch = x;
                    });
                    return {
                        ...row,
                        no: i + 1,
                        levelName: res.level.name,
                        branchName: res.branch.name,
                        itemName: res.item.name,
                        unitName: res.unit.name,
                    };
                });
                setData(data2);
                setFetching(false);
                setIsSearch(false);
            })
            .catch((err) => {
                setFetching(false);
                setData([]);
            });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            parms: {
                iempid: sto.empi,
                tname: "pricelevel",
                branch: sto.branchi,
                db_name: sto?.db_name,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                // setPumpsReports(res.data?.Pumps);
                setRptParams({
                    ...
                    valueLevels,
                    id: res.data.other?.lastid
                });
                setRptParamsAuto(AutoValueLevels);
            })
            .catch((error) => {
            });
    };
    // useEffect(() => {
    //     if(isSearch){
    //         viewHandle();
    //     };
    //   }, [isSearch]);
    const handNewLevels = () => {
        reloadGets();
        setRptParamsAuto(AutoValueLevels);
        // setRptParams(valuePupms);
        setPrevent(true);
    };
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "save") { handNewLevels(); }
            if (prop === "update") { handNewLevels(); }

            else if (prop === "delete") { handNewLevels(); }
            else {
                handNewLevels();
            }
            setPrevent(true);
        }, 2000);
    };

    const addToBS = (props) => {
        if (rptParams.branch !== "" && rptParams.branch != null &&
            rptParams.item != null && rptParams.item !== "" &&
            rptParams.level != null && rptParams.level !== "" &&
            rptParams.unit != null && rptParams.unit !== "") {
            ButtonLoading("save");
            prevent
                ? axios
                    .post(uri + "Priceslevels", rptParams)
                    .then((res) => {
                        if (res.data?.data != null) {

                            ButtonSuccess("save", 1000);
                            setIsSearch(true);
                            toast.success(t("save-success"));
                        } else {
                            ButtonSuccess("save", 1000);
                            setIsSearch(true);
                            toast.success(t("save-success"));
                        }

                    })
                    .catch((res) => {
                        ButtonSuccess("save", 1000);
                        toast.error(t("save-failed"));

                    })
                :
                axios
                    .put(uri + "Priceslevels", rptParams)
                    .then((res) => {
                        ButtonSuccess("update", 1000);
                        setIsSearch(true);
                        toast.success(t("update-success"));
                    })
                    .catch((res) => {
                        ButtonSuccess("update", 1000);
                        toast.error(t("update-process-error"));

                    });
        } else {
            alert(t("confirm-complete-data"));
        }
    };



    const handleDeleteRow = async (e, row) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `Priceslevels?id=${row?.id}`
        } else {
            Urls = `Priceslevels?id=${row?.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri + Urls).then(res => {
            if (res.data === "no") {
                alert(t("delete-process-error"));
            } else {
                toast.success(t("delete-success"));
                ButtonSuccess("delete", 1000);
                setIsSearch(true);
            }

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"));
        })
    };

    const deleteToI = async (e) => {
        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `Priceslevels?id=${rptParams?.id}`
        } else {
            Urls = `Priceslevels?id=${rptParams?.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri + Urls).then(res => {
            toast.success(t("delete-success"));
            ButtonSuccess("delete", 1000);
            setIsSearch(true);
        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
                    color="primary"
                >
                    {t("item-price-levels")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip} >

                    <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip} >

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <PricesLevelsForms
                                {...{
                                    AutoOptions,
                                    rptParams,
                                    onChangeData,
                                    onChangeAutoData,
                                    rptParamsAuto,
                                    onChangeSearch,
                                    changTField,
                                    optionsUnits,
                                }}
                            />

                        </Container>
                    </Grid>
                    <Grid container lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                marginTop: "0.5rem"
                            }}
                        >
                            <Grid item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip} >
                                <PricesLevelsFSearch
                                    {...{
                                        AutoOptions,
                                        rptParams,
                                        onChangeData,
                                        onChangeAutoData,
                                        fetching,
                                        clasui,
                                        viewHandle,
                                        style,
                                        rptParamsAuto
                                    }}
                                />

                            </Grid>

                            <Grid container lg={12} md={12} sm={12} xm={12} justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.red[300]} />
                                    {!fetching && (
                                        <PricesLevelsTable
                                            {...{
                                                data: data ? data : [],
                                                setConfirmDialog,
                                                handleDeleteRow,
                                                onRowClick
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                <DeleteConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Typography>
            <PumpsAppbar {...{
                rptParams,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent
            }}
            />
        </div>
    );
}
